export const TRACKING_EVENT_NAME = {
  HEARTBEAT: "heartbeat",
  PAGE_VIEW: "page_view",
  VEHICLE_SELECTED: "vehicle_selected",
  CATEGORY_PAGE_VIEW: "category_view",
  PRODUCT_PAGE_VIEW: "product_view",
  ADD_TO_CART: "add_to_cart",
  MODIFY_CART: "modify_cart",
  ORDER_PLACED: "order_placed",
  GA_NOT_LOADED: "missing_ga",
  ORDER_ID_SYNC_SUCCESS: "order_id_sync_success",
  ORDER_ID_SYNC_FAILED: "order_id_sync_failed",
  CANADA_POST_SELECT_ADDRESS: "canada_post_select_address",
  CANADA_POST_SELECT_PAYMENT_ADDRESS: "canada_post_select_payment_address",
  MANUFACTURER_CATEGORY_PAGE_VIEW: "manufacturer_category_view",
  FITMENT_PROMPTED: "fitment_prompted",
  FITMENT_SELECTED: "fitment_selected",
  FITMENT_MODAL_CLOSED: "fitment_modal_closed",
  FITMENT_OPTION_CLEARED: "fitment_option_cleared",
};

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    version: any;
    showLogs: any;
    trackingDataLayer: any;
    doNotTrack: any,
    Spreedly: any;
    SpreedlyHostedFields: any;
    Sentry: any;
    dataLayer: any;
  }
}
